import "../../types/customizer-global";
import {
  MICRO_CHECKBOX,
  OUTLINE_TEXT,
  SCRIPT_TEXT_INPUT,
} from "../4-one-of-one/_selectors";
import generateCanvas from "../4-one-of-one/generateCanvas";
import { OUTLINE_SWATCH_SELECTOR } from "../constants/selectors";
import selectAllElements from "../dom/selectAllElements";
import selectSingleElement from "../dom/selectSingleElement";

function outlineSwatchSetup(currentColor = "transparent") {
  const outlineSwatches = selectAllElements(OUTLINE_SWATCH_SELECTOR);
  if (outlineSwatches !== null) {
    for (const swatch of outlineSwatches) {
      swatch.addEventListener("click", function setOutlineInputValue(e) {
        const target = e.target as HTMLElement;
        const color = target.dataset.color ?? currentColor;
        const script = selectSingleElement<HTMLInputElement>(SCRIPT_TEXT_INPUT);
        const microScript = selectSingleElement<HTMLInputElement>(MICRO_CHECKBOX);
        const microCheckbox = microScript; // Use the same MICRO_CHECKBOX selector
        const scriptValue = script?.value;
        const microValue = microScript?.value;
        let text = "";

        if (microCheckbox?.checked && microValue) {
          text = microValue;
          const outlineInput = selectSingleElement<HTMLInputElement>(OUTLINE_TEXT);
          if (outlineInput) outlineInput.value = microValue;
          generateCanvas({
            color,
            text,
            id: "outline",
            withStroke: true,
            strokeXRatio: 2,
            strokeYRatio: 2.375,
            lineWidth: 0.5,
          });
        } else if (scriptValue) {
          text = scriptValue;
          // Use the global font state instead of searching DOM
          const font = window.currentCustomizerFont || "HoodScript";

          console.log("selected font", font);
          const mqMinus640 = window.matchMedia("(max-width: 640px)");
          const mqPlus640 = window.matchMedia("(min-width: 641px)");
          const mqMinus414 = window.matchMedia("(max-width: 414px)");
          const isAndroid = /Android/.test(navigator.userAgent);

          if (isAndroid && navigator.userAgent.match(/Chrome/i)) {
            if (mqMinus640.matches) {
              console.log("This is Android or Chrome and less than 640px");
              generateCanvas({
                color: currentColor,
                text,
                id: "outline",
                withStroke: true,
                font,
                strokeYRatio: 2.325,
              });
            } else if (mqPlus640.matches) {
              console.log("This is Android or Chrome and more than 640px");
              generateCanvas({
                color,
                text,
                id: "outline",
                withStroke: true,
                font,
                strokeYRatio: 2.5,
              });
            }
          } else {
            console.log("This is other or iOS Safari");
            if (mqMinus414.matches) {
              generateCanvas({
                color,
                text,
                id: "outline",
                withStroke: true,
                font,
                strokeYRatio: 2.325,
              });
            } else {
              generateCanvas({
                color,
                text,
                id: "outline",
                withStroke: true,
                font,
              });
            }
          }
          const outlineInput = selectSingleElement<HTMLInputElement>(OUTLINE_TEXT);
          if (outlineInput) outlineInput.value = scriptValue;
          console.log("outline canvas generate, font:", font);
        }
      });
    }
  }
}

export default outlineSwatchSetup;
